"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_HEIGHT = exports.DEFAULT_WIDTH = exports.JS_API_INVOKE_MINI_PROGRAM = exports.WE_APP_OPEN_TAG = exports.TENCENT_DOCS_MINI_PROGRAM_ORIGINAL_ID = exports.TENCENT_DOCS_OFFICIAL_ACCOUNT_APP_ID = exports.WX_JS_SDK_VERSION_ID = exports.WS_JS_SDK_LINK = exports.WX_SIGNATURE_URI = exports.WX_SDK_RETRY_TIME = void 0;
/* 尝试加载 WX SDK 重试次数 */
exports.WX_SDK_RETRY_TIME = 2;
/** WX SDK 签名链接 */
exports.WX_SIGNATURE_URI = '/v2/util/wechat/signature';
/** WX SDK 版本链接 */
exports.WS_JS_SDK_LINK = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
/** WX SDK 版本ID */
exports.WX_JS_SDK_VERSION_ID = 'wx-js-sdk-script-1-6-0';
/** 腾讯文档公众号APP ID */
exports.TENCENT_DOCS_OFFICIAL_ACCOUNT_APP_ID = 'wx46dfe750eef96da7';
/** 腾讯文档小程序原始ID */
exports.TENCENT_DOCS_MINI_PROGRAM_ORIGINAL_ID = 'gh_252c5f06840b';
/** 微信H5跳转小程序开放标签 */
exports.WE_APP_OPEN_TAG = 'wx-open-launch-weapp';
exports.JS_API_INVOKE_MINI_PROGRAM = 'invokeMiniProgramAPI';
exports.DEFAULT_WIDTH = '100%';
exports.DEFAULT_HEIGHT = '100%';
